module.exports = __webpack_public_path__ + "img/account-user-add.39c36329.svg";